import { IApplicationState } from '../../types/redux';

export const getCons = (state: IApplicationState): string => {
  return state.newReview.data.cons || '';
};
